exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-locale-select md-input-container{box-sizing:border-box;width:100%}gz-locale-select md-input-container md-select-value .secondary{display:none}gz-locale-select md-input-container md-select-value .language-container{align-items:center}.gz-locale-select-menu md-option .md-text{flex:1}md-optgroup .gz-locale-select-menu md-option{padding-right:16px}.gz-locale-select-menu md-option .secondary{color:#ccc;font-style:italic;font-size:14px}.gz-locale-select-menu md-optgroup>label{border-top:1px solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/locale-select/locale-select.scss
// module id = 115
// module chunks = 0